export interface LegalVersionInfo {
    latest_version: string;
    url: string;
}

export interface LegalInfo {
    currentCulture: string;
    dip_privacy_policy: LegalVersionInfo;
    dip_terms_and_conditions: LegalVersionInfo;
}

export enum LegalInfoActionTypes {
    SET_LEGALINFO = '@@translation/SET_LEGALINFO',
    GET_LEGALINFO = '@@translation/GET_LEGALINFO'
}
